import React from 'react';

import { FormBase } from '../Interface';
import { useEmployeeAttendance } from '../../hooks/useEmployeeAttendance';
import { EmployeeAttendancePage } from './EmployeeAttendancePage';
import EmployeeAttendanceReports from './EmployeeAttendanceReports';

export const EmployeeAttendanceMain = () => {
  const employeAttendanceState = useEmployeeAttendance();

  return (
    <FormBase
      name="EmployeeAttendance"
      leftPanelContent={<EmployeeAttendancePage employeAttendanceState={employeAttendanceState} />}
      rightPanelContent={<EmployeeAttendanceReports employeAttendanceState={employeAttendanceState} />}
    ></FormBase>
  );
};
